import { render, staticRenderFns } from "./TradeRequestDirectForm.vue?vue&type=template&id=1ad14b4c"
import script from "./TradeRequestDirectForm.vue?vue&type=script&lang=js"
export * from "./TradeRequestDirectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports